import React from 'react';
import Select, { components } from 'react-select';
import { IconLoader } from 'common/IconLoader';

import './MapView.css';
import SvgAF from 'components/shared/SvgAF/SvgAF';

const mapLayerOptions = [
  { value: 'googleMap', label: 'Google map' },
  { value: 'openStreetMap', label: 'OSM' }
];

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    width: '60%'
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#000',
    background: '#fff',
    fontWeight: 400
  }),
  control: (provided, state) => ({
    ...provided,
    border: 0,
    boxShadow: 'none'
  })
};

const ValueContainer = ({ children, ...props }) => {
  return (
    <div className="MapView_Select_Value">
      <>{children}</>
      <div className="MapView_Select_Arrow">
        <SvgAF img={IconLoader.icon_arrows} hover={IconLoader.icon_arrows_hover} />
      </div>
    </div>
  );
};

const Option = ({ children, ...props }) => (
  <components.Option {...props}>
    <div className="MapView_Select_Option">
      {props.isSelected && (
        <div className="MapView_Select_Option_Icon">
          <img src={IconLoader.icon_action_check} alt={children} />
        </div>
      )}
      <span className="MapView_Select_Option_Label">{children}</span>
    </div>
  </components.Option>
);

const MapView = (props) => {
  const { changeTileProvider, tileProviderName } = props;

  const handlerMapLayerChange = (selectedMapLayer) => {
    changeTileProvider(selectedMapLayer.value);
  };

  return (
    <div
      className="MapView"
      onClick={props.stopPolygonEditingShape}
    >
      <Select
        isSearchable={false}
        isClearable={false}
        hideSelectedOptions={false}
        menuPlacement="top"
        blurInputOnSelect={true}
        defaultValue={mapLayerOptions.find((mapLayer) => mapLayer.value === tileProviderName)}
        options={mapLayerOptions}
        components={{ ValueContainer, Option, IndicatorsContainer: () => null }}
        onChange={handlerMapLayerChange}
        styles={customStyles}
      />
    </div>
  );
};

export default MapView;
